import { emptyDictionariesState } from 'ducks/dictionaries/state'
import { getFileCategoriesRoutine } from 'ducks/dictionaries/actions'
import { getFoldersRoutine } from 'ducks/dictionaries/actions'

export default (state = emptyDictionariesState, action) => {
  switch (action.type) {
    case getFileCategoriesRoutine.SUCCESS:
      return {
        ...state,
        fileCategories: action.payload
      }
    case getFoldersRoutine.SUCCESS:
      return {
        ...state,
        folders: action.payload
      }
    default:
      return state
  }
}
